<template>
    <v-container>
        <v-layout
        text-xs-center
        wrap> 
        
        <v-flex xs12 md8 offset-md2 justify-center>
            <v-dialog
                    v-model="dialog"
                    hide-overlay
                    persistent
                    width="300"
                    >
                    <v-card
                        color="#97c763"
                        dark
                    >
                        <v-card-text>
                        กำลังโหลด
                        <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                        ></v-progress-linear>
                        </v-card-text>
                    </v-card>
                    </v-dialog>

                <v-layout wrap>
                     <v-flex xs12 md6 offset-md3  text-xs-center>
                         <img src="../assets/head.png" width="350px" class="img-align">
                        <router-link to="/report"> <h2 class="font-weight-light" >สรุปผลการสัมภาษณ์</h2></router-link><br>
                         <h1 class="font-weight-light">รายชื่อผู้เข้าสัมภาษณ์ <br> สมัครงานกับ Homepro</h1><br>
                        <h2 class="font-weight-light">กรุณากรอกเบอร์โทรศัพท์</h2>
                        <masked-input  class="telBox" v-model="telNum" mask="111-1111-111" placeholder="08X-XXX-XXXXX" @input="search">
                        </masked-input>
                    </v-flex>
                    <v-flex xs12 md6 offset-md3  text-xs-center v-if="data.length > 0">
                       <h4 class="font-weight-light" v-if="data[0].interviewTime !== ''">({{data[0].interviewTime}})</h4>
                    </v-flex>
                </v-layout>
                <br>
                <v-layout wrap v-if="data.length > 0">
                 
                    <v-flex md6 xs12 offset-md3 text-xs-left>
                        <v-text-field
                            label="ชื่อ-นามสกุล"
                            :value="data[0].fullName"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md2 offset-md3 text-xs-left>
                        <v-text-field
                            label="อายุ"
                            :value="data[0].age"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 offset-md1 text-xs-left>
                        <v-text-field
                            label="เบอร์โทรศัพท์"
                            :value="data[0].tel"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12 offset-md3 text-xs-left>
                        <v-text-field
                            label="อีเมล"
                            :value="data[0].email"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12 offset-md3 text-xs-left>
                        <v-textarea
                            label="ที่อยู่"
                            :value="data[0].address"
                        ></v-textarea>
                    </v-flex>
                    <br>
                    <v-flex md6 xs12 offset-md3 text-xs-left>
                        <v-text-field
                            label="ตำแหน่งที่สมัคร"
                            :value="data[0].position"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12 offset-md3 text-xs-left>
                        <!-- ประสบการณ์การทำงาน -->
                    </v-flex>
                    <v-flex xs12 md2 offset-md3 text-xs-left>
                        <v-text-field
                            label="ประสบการณ์การทำงาน"
                            :value="data[0].hasExp"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md3 xs12 offset-md1 text-xs-left>
                        <v-text-field
                            label="ด้าน"
                            :value="data[0].experience"
                        ></v-text-field>
                    </v-flex>
                     <v-flex md6 xs12 offset-md3 text-xs-left>
                        <v-textarea
                            label="ประสบการณ์การทำงาน"
                            :value="data[0].carreerHistory"
                        ></v-textarea>
                    </v-flex>
                     <v-flex md6 xs12 offset-md3 text-xs-left>
                        <v-textarea
                            label="แรงบันดาลใจ"
                            :value="data[0].inspiration"
                        ></v-textarea>
                    </v-flex>
                     <v-flex md6 xs12 offset-md3 text-xs-left>
                        <v-text-field
                            label="วุฒิการศึกษา"
                            :value="data[0].education"
                        ></v-text-field>
                    </v-flex>
                     <v-flex md6 xs12 offset-md3 text-xs-left>
                         <v-text-field
                            label="สามารถทำงานเป็นกะได้หรือไม่"
                            :value="data[0].canShiftWork"
                        ></v-text-field>
                         <!-- สามารถทำงานเป็นกะได้หรือไม่ <br>
                         <v-chip :color="chipColor1" text-color="white">ได้</v-chip>
                         <v-chip :color="chipColor2" text-color="white">ไม่ได้</v-chip> -->
                    </v-flex>
                     <v-flex md6 xs12 offset-md3 text-xs-left>
                        <v-text-field
                            label="สุขภาพและโรคประจำตัว"
                            :value="data[0].health"
                        ></v-text-field>
                    </v-flex>
                     <v-flex md6 xs12 offset-md3 text-xs-left>
                         ประเมินความพร้อมและศักยภาพในการทำงานของตัวเอง
                         <v-rating v-model="data[0].potential" color="#DB595A"></v-rating>
                        <!-- <v-text-field
                            label="ประเมินความพร้อมและศักยภาพในการทำงานของตัวเอง"
                            :value="data[0].potential"
                        ></v-text-field> -->
                    </v-flex>
                     <v-flex md6 xs12 offset-md3 text-xs-left>
                        <v-text-field
                            label="Homepro สาขาที่ชอบไป"
                            :value="data[0].branch"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12 offset-md3 text-xs-left>
                        <v-radio-group v-model="data[0].result">
                            <v-radio label="ผ่าน" value="1"></v-radio>
                            <v-radio label="ไม่ผ่าน" value="0"></v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex md6 xs12 offset-md3 text-xs-left>
                        <v-textarea
                            label="อื่นๆ"
                            :value="data[0].comment"
                            v-model="data[0].comment"
                        ></v-textarea>
                    </v-flex>
                    <v-flex md6 xs12 offset-md3 text-xs-center>
                        <v-btn color="#97c763" dark @click="saveResult">บันทึก</v-btn>
                        <br><br><br><br>
                    </v-flex>
                    
                </v-layout>
        </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import firebase from 'firebase'
import MaskedInput from 'vue-masked-input' 

export default {
    components: { 
        MaskedInput 
    },
    data () {
        return {
            telNum: "",
            user: [],
            success: false,
            data: {},
            chipColor1: '',
            chipColor2: '',
            resultInterview: '',
            commentInterview: '',
            tempUser: [],
            dialog: false
        }
    },
    async created () {
        let id = this.$route.params.id
        if (this.$route.params.id !== undefined) {
            this.dialog = true
            const db = await firebase.database().ref('/'+this.$route.params.id).once('value').then(function(snapshot) {
                let e = snapshot.val()

                let tempShift = ''
                if (e.canShiftWork === 0) {
                    tempShift = 'ไม่ได้'
                } else {
                    tempShift = 'ได้'
                }

                let tempExp = ''
                if (e.experience === "") {
                    tempExp = 'ไม่เคย'
                } else {
                    tempExp = 'เคย'
                }

                let interviewTime = ''
                if (e.interviewTime === 'รอบเช้า') {
                    interviewTime = 'วันที่ 14 ธ.ค. 2561 รอบเช้า เวลา 10.00-12.00 น.'
                } else if (e.interviewTime === 'รอบบ่าย') {
                    interviewTime = 'วันที่ 14 ธ.ค. 2561 รอบบ่าย เวลา 13.00-16.00 น.'
                }

                // this.resultInterview = e.result
                let temp = {
                    name: e.name,
                    lastName: e.lastName,
                    tel: e.tel,
                    fullName: e.name + ' '+ e.lastName,
                    age: e.age,
                    email: e.email,
                    address: e.address,
                    position: e.position,
                    experience: e.experience,
                    hasExp: tempExp,
                    canShiftWork: tempShift,
                    health: e.health,
                    disease: e.disease,
                    potential: e.potential,
                    education: e.education,
                    other: e.other,
                    branch: e.branch,
                    productBought: e.productBought,
                    carreerHistory: e.carreerHistory,
                    inspiration: e.inspiration,
                    interviewTime: interviewTime,
                    key: parseInt(id),
                    comment: e.comment,
                    result: e.result
                }
                return temp
            })
            this.data.push(db)
            this.telNum = db.tel
            this.dialog = false
            // this.filterId(this.$route.params.id)
        } 
    },
    mounted () {
        const db = firebase.database().ref().once('value', (data) => {
            data.forEach(e => {
                let user = e.child('tel').val()
                let tempShift = ''
                if (e.child('canShiftWork').val() === 0) {
                    tempShift = 'ไม่ได้'
                } else {
                    tempShift = 'ได้'
                }

                let tempExp = ''
                if (e.child('hasExperience').val() === 0) {
                    tempExp = 'ไม่เคย'
                } else {
                    tempExp = 'เคย'
                }

                let interviewTime = ''
                if (e.child('interviewTime').val() === 'รอบเช้า') {
                    interviewTime = 'วันที่ 14 ธ.ค. 2561 รอบเช้า เวลา 10.00-12.00 น.'
                } else if (e.child('interviewTime').val() === 'รอบบ่าย') {
                    interviewTime = 'วันที่ 14 ธ.ค. 2561 รอบบ่าย เวลา 13.00-16.00 น.'
                }

                this.resultInterview = e.child('result').val()
                let temp = {
                    name: e.child('name').val(),
                    lastName: e.child('lastName').val(),
                    tel: '0'+e.child('tel').val(),
                    fullName: e.child('name').val() + ' '+ e.child('lastName').val(),
                    age: e.child('age').val(),
                    email: e.child('email').val(),
                    address: e.child('address').val(),
                    position: e.child('position').val(),
                    experience: e.child('experience').val(),
                    hasExp: tempExp,
                    canShiftWork: tempShift,
                    health: e.child('health').val(),
                    disease: e.child('disease').val(),
                    potential: e.child('potential').val(),
                    education: e.child('education').val(),
                    other: e.child('other').val(),
                    branch: e.child('Branch').val(),
                    productBought: e.child('productBought').val(),
                    carreerHistory: e.child('careerHistory').val(),
                    inspiration: e.child('inspiration').val(),
                    interviewTime: interviewTime,
                    key: e.key,
                    comment: e.child('comment').val(),
                    result: e.child('result').val()
                }
                this.user.push(temp)
            })
        })
    },
    methods: {
        async search() {
            let [first,sec,third] = this.telNum.split('-')
            let telTemp = first+sec+third
            this.data = await this.user.filter(e => {
                return e.tel === telTemp
            })
            if (this.data.length > 0) {
                if (this.data[0].canShiftWork === 0) {
                this.chipColor1 = "#9E9C9C"
                this.chipColor2 = "#97c763"
                } else {
                    this.chipColor2 = "#9E9C9C"
                    this.chipColor1 = "#97c763"
                }
            }
            
        },
        saveResult() {
            let comment = ''
            if(this.data[0].comment === null || this.data[0].comment === undefined) {
                comment = ''
            } else {
                comment = this.data[0].comment
            }
            // this.$swal('hello world')
            this.$swal("ยืนยันการทำรายการ", {
            buttons: {
                cancel: "ยกเลิก",
                save: {
                    text: "ตกลง",
                    value: "save",
                },
            },
            })
            .then((value) => {
                switch (value) {
                    case "save":
                    firebase.database().ref(this.data[0].key).update({
                        result: this.data[0].result,
                        comment: comment
                    }).then(e => {
                        swal("เรียบร้อย!", "บันทึกข้อมูลเรียบร้อย", "success");
                    })
                    break;

                    case "cancel":
                    break;
                }
            });
        }
        
    },
    computed: {
        result () {
            return this.tempUser.filter(e => {
                return e.tel.includes(this.telNum)
            })
        }
    }
    
}
</script>

<style>
.telBox { 
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
  text-align: center;
  background-color: #f8f8f8;
  font-size: 18px;
  border-radius: 4px;
  border: 2px solid #ccc;
}

.img-align {
    align-self: center;
    /* padding-right: 100px; */
}

</style>
